export enum ShiftEnum {
  Morning = 1,
  Noon = 2,
  Night = 3,
}
